<template>
  <div class="vouchers-list-item-rollout">
    <div class="vouchers-list-item-rollout__details">
      <h6 class="vouchers-list-item-rollout__name">
        VOUCHER: {{ voucher.id.slice(0, 8) }}
      </h6>
      <div class="vouchers-list-item-rollout__sub-details">
        <p v-if="!isActive" class="vouchers-list-item-rollout__subdetail">
          Status: Inactive
        </p>
        <p class="vouchers-list-item-rollout__subdetail">
          Expires: {{ expiryDate }}
        </p>
        <p class="vouchers-list-item-rollout__subdetail">
          Purchased: {{ purchaseDate }}
        </p>
        <p class="vouchers-list-item-rollout__subdetail">${{ cost }}</p>
      </div>
    </div>
    <div v-if="allAttempts.length" class="vouchers-list-item-rollout__attempts">
      <div class="vouchers-list-item-rollout__attempts-columns">
        <p class="vouchers-list-item-rollout__column">Exam Started</p>
        <p class="vouchers-list-item-rollout__column">Submitted</p>
        <p class="vouchers-list-item-rollout__column">Status</p>
      </div>
      <VouchersListItemAttempt
        v-for="(attempt, i) in allAttempts"
        :key="attempt.id"
        :attempt="attempt"
        :index="i"
      />
    </div>
    <VouchersListItemAttemptEmpty v-else />
  </div>
</template>

<script>
import { format } from 'date-fns-tz'
import VouchersListItemAttempt from '@/components/user-dashboard/certifications/VouchersListItemAttempt.vue'
import VouchersListItemAttemptEmpty from '@/components/user-dashboard/certifications/VouchersListItemAttemptEmpty.vue'

export default {
  name: 'VoucherListItemRollout',
  components: { VouchersListItemAttempt, VouchersListItemAttemptEmpty },
  props: {
    voucher: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    expiryDate() {
      const { expiration_date } = this.voucher
      return this.formatDate(expiration_date)
    },
    purchaseDate() {
      const { created } = this.voucher
      return this.formatDate(created)
    },
    cost() {
      const { price } = this.voucher
      return price || 0
    },
    activeAttempts() {
      return this?.voucher?.active_attempts ?? []
    },
    inactiveAttempts() {
      return this?.voucher?.inactive_attempts ?? []
    },
    allAttempts() {
      return [...this.activeAttempts, ...this.inactiveAttempts]
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'LLL d, yyyy')
    },
  },
}
</script>

<style lang="scss">
.vouchers-list-item-rollout {
  color: var(--white);
  background: linear-gradient(
    104.99deg,
    rgba(62, 63, 73, 0.7) -13.91%,
    rgba(62, 63, 73, 0) 100.48%
  );
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  @include tablet {
    flex-wrap: nowrap;
    padding: 30px;
  }
  &:last-of-type {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  &__name {
    padding: 0;
    margin: 0;
    font-size: rem(18);
    line-height: 24px;
  }
  &__details {
    width: 100%;
    @include tablet {
      width: 35%;
    }
  }
  &__sub-details {
    color: var(--light-blue-gray);
    opacity: 0.99;
    margin: 15px 0px;
  }
  &__subdetail {
    margin: 0;
    padding: 0;
    font-size: rem(16);
    line-height: 24px;
  }
  &__attempts {
    width: 100%;
  }
  &__attempts-columns {
    display: flex;
    width: 100%;
    margin: 30px 0 10px 0;
    @include tablet {
      margin: 4px 0 10px 0;
    }
  }
  &__column {
    text-transform: uppercase;
    font-size: rem(12);
    line-height: 14px;
    color: var(--white);
    opacity: 0.99;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    width: 33.33%;
  }
}
</style>
